import apiClient from '@/plugins/axios'

export default {
  getPendencias() {
    return apiClient.get('pendencia')
  },

  getPendencia(id) {
    return apiClient.get(`pendencia/${id}`)
  },

  postPendencia(pendencia) {
    return apiClient.post(`pendencia`, { pendencia })

  },

  putPendenciao(id, pendencia) {
    return apiClient.put(`pendencia/${id}`, { pendencia })

  },

  deletePendencia(id) {
    return apiClient.delete(`pendencia/${id}`)

  },

}


// WEBPACK FOOTER //
// ./src/views/Pendencia/_services/PendenciaService.js